export default __webpack_public_path__ + "static/media/07.64df9af0.png";